import React from 'react';
import { Button } from "@blueprintjs/core";

import InterludeResourcesViewer from '../ResourceViewer/Interlude';

class InterludesMonitor extends React.Component {
    render() {
        const {
            sessionInstance,
            interludeDisplayed,
            session,
            onPrevInterlude,
            onFirstInterlude,
            onNextInterlude,
            onLastInterlude,
            isNextDisabled,
            isPrevDisabled
        } = this.props;

        return (
            <div className="interludes-wrapper animated fadeIn">
                <div className="row resources">
                    <InterludeResourcesViewer
                        instance={sessionInstance}
                        interludeDisplayed={interludeDisplayed} />
                </div>
                <div className="nav text-center" style={{marginTop: "5px"}}>
                    <Button
                        icon='double-chevron-left'
                        onClick={onFirstInterlude}
                        disabled={isPrevDisabled()}
                        style={{ marginRight: '5px' }} />
                    <Button
                        icon='chevron-left'
                        onClick={onPrevInterlude}
                        disabled={isPrevDisabled()}
                        className="large-padding" />
                    <span className="pagination">
                        <span className="muted">
                            Introduction
                        </span>
                        &nbsp;{sessionInstance.currentInterlude + 1}&nbsp;
                        <span className="muted">
                            of
                        </span>
                        &nbsp;{session.data.interludes.length}
                    </span>
                    <Button
                        rightIcon='chevron-right'
                        onClick={onNextInterlude}
                        disabled={isNextDisabled()}
                        className="large-padding" />
                    <Button
                        rightIcon='double-chevron-right'
                        onClick={onLastInterlude}
                        disabled={isNextDisabled()}
                        style={{ marginLeft: '5px' }} />
                </div>
            </div>
        );
    }
}

export default InterludesMonitor;